import { render, staticRenderFns } from "./IconsBaseCheckbox.vue?vue&type=template&id=4dfab2d2&scoped=true&"
import script from "./IconsBaseCheckbox.vue?vue&type=script&lang=js&"
export * from "./IconsBaseCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfab2d2",
  null
  
)

export default component.exports